import { getDataFromServer } from "../util";

export const getInvestments = () => getDataFromServer("GET", "/investment/all", null, true);
export const getInvestmentHistory = id => getDataFromServer("GET", `/investment/${id}/history`, null, true);
export const getInvestmentMonthYield = (id, month, year) =>
  getDataFromServer("GET", `/investment/${id}/month/${month}/year/${year}`, null, true);
export const setInvestment = formProps => getDataFromServer("POST", "/investment", formProps, true);
